<template>
   <scroll-pages></scroll-pages>
</template>

<script>
import {LOCAL_HOST,SCHEDULER_URL} from '@/constants/general_constants';
import ScrollPages from '@/components/ThemeCosmic/pages/partialsCommon/ScrollPages';
 export default {
     
    name: 'Footer',
    components:{
       ScrollPages
    },
    data(){
        return{
            LOCAL_HOST:LOCAL_HOST,
            SCHEDULER_URL:SCHEDULER_URL
        }
    },

    created() {
        this.loadExternalScript(LOCAL_HOST+"/ThemeCosmic/js/jquery.waypoints.min.js"),
        this.loadExternalScript(LOCAL_HOST+"/ThemeCosmic/js/jquery.flexslider-min.js"),
        this.loadExternalScript(LOCAL_HOST+"/ThemeCosmic/js/jquery.magnific-popup.min.js"),

        this.loadExternalScript(LOCAL_HOST+"/ThemeCosmic/js/sticky-kit.min.js"),
        this.loadExternalScript(LOCAL_HOST+"/ThemeCosmic/js/main.js"),
        this.loadExternalScript(SCHEDULER_URL),
       
        window.$ = window.jQuery = require('jquery')
        
    },
    methods:{
        loadExternalScript(path_to_file){
            const plugin = document.createElement("script");
            plugin.setAttribute(
            "src",
            path_to_file
            );
            plugin.async = true;
            document.body.appendChild(plugin);
        }
    }

    
};
</script>
<style>
.btn {
    margin: 0rem !important;
}
.btn-primary {
    /* background: #F75940 !important; */
    background: #0F2D59 !important;    
    color: #fff !important;
    border: 2px solid #0F2D59 !important;
}
.pagination {
    margin: 0 !important;
}
body{
    font-weight: normal !important;
    color: rgb(0 0 0 / 95%) !important;
}
</style>